import { LayerDefinition } from './types';

export const cloudBaseDefinition: LayerDefinition = {
  id: 'cloud_base',
  name: 'Cloud Base Elevation',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '☁️',
  description: `Cloud Base Elevation maps the absolute Mean Sea Level (MSL) altitude of the lowest cloud deck and ceiling across the landscape.

Knowing the exact cloud base altitude is critical for backcountry hikers, mountaineers, climbers, and landscape photographers. It indicates the exact elevation where trails enter fog, rain, and whiteout conditions, and reveals when summits, ridgelines, and alpine passes are clear of cloud cover.

The layer uses high-resolution National Blend of Models (NOAA NBM) aviation ceiling and lowest cloud base fields combined with high-resolution digital elevation modeling. Clear skies with absent or high cirrus clouds are rendered transparent so the underlying terrain remains visible, while active cloud decks are rendered with a continuous elevation gradient from sea level up to 16,000 ft MSL.`,
  scoreDescription: `• Purple/Violet (0 - 3,000 ft MSL): Very low cloud base or sea-level marine stratus and coastal fog.
• Blue to Cyan (3,000 - 6,000 ft MSL): Low-to-mid mountain cloud deck covering foothills and lower trailheads.
• Teal to Emerald Green (6,000 - 9,000 ft MSL): Subalpine cloud ceiling; peaks above 9,000 ft extend above the clouds.
• Yellow to Amber (9,000 - 12,000 ft MSL): High-altitude mountain cloud deck; alpine terrain below 9,000 ft remains in clear air.
• Orange to Red/Magenta (12,000 - 16,000+ ft MSL): High cloud bases; only the highest continental summits are obscured.
• Transparent: Clear skies (no low cloud deck or ceiling detected).`,
  sourceModels: ['nbm'],
  outputModels: ['Cloud Base Elevation (.pmtiles)'],
  config: {
    defaultModel: 'nbm'
  }
};

export default cloudBaseDefinition;
